export default __webpack_public_path__ + "static/media/Alberto.9fbf5800.jpg";